import React, {Component} from "react";

export default class Snow extends Component {
    /**
     * Current snow interval ID
     */
    intervalId = null;

    ww = 0;
    wh = 0;
    maxw = 0;
    minw = 0;
    maxh = 0;
    xv = 0;
    prevTime = null;
    absMax = 30;
    flakeCount = 0;
    moveSize = 300;
    interval = 15000;
    lifeCycle = 45000;

    componentDidMount = () => {
        this.detectSize();

        window.jQuery(window).resize(this.detectSize);

        let i = 30;
        while (i--) {
            this.addFlake(true);
        }

        this.prevTime = new Date().getTime();
        this.intervalId = setInterval(this.move, this.interval);
    };

    componentWillUnmount() {
        window.jQuery("span.snow-flake").remove();
        window.jQuery(window).unbind("resize");

        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
        }
    }

    detectSize = () => {
        this.ww = window.jQuery(window).width();
        this.wh = window.jQuery(window).height();

        this.maxw = this.ww + this.moveSize;
        this.minw = -this.moveSize;
        this.maxh = this.wh + this.moveSize;
    };

    getSnowFlakeType = () => {
        switch (Math.floor(Math.random() * 3)) {
            case 0:
                return "\u2744";
            case 1:
                return "\u2745";
            case 2:
                return "\u2746";
            default:
                return "*";
        }
    };

    buildSnowFlake = () => {
        return window.jQuery("<span class='snow-flake'>" + this.getSnowFlakeType() + "</span>").css({
            color: "#48A7CA",
            display: "block",
            position: "fixed",
            background: "transparent",
            width: "auto",
            height: "auto",
            margin: "0",
            padding: "0",
            textAlign: "left",
            zIndex: 10002
        });
    };

    addFlake = (initial) => {
        this.flakeCount++;

        let sizes = [
            {
                r: 1.0,
                css: {
                    fontSize: 15 + Math.floor(Math.random() * 20) + "px",
                    textShadow: "9999px 0 0 rgba(238, 238, 238, 0.5)"
                },
                v: 2
            },
            {
                r: 0.6,
                css: {
                    fontSize: 50 + Math.floor(Math.random() * 20) + "px",
                    textShadow: "9999px 0 2px #eee"
                },
                v: 6
            },
            {
                r: 0.2,
                css: {
                    fontSize: 90 + Math.floor(Math.random() * 30) + "px",
                    textShadow: "9999px 0 6px #eee"
                },
                v: 12
            },
            {
                r: 0.1,
                css: {
                    fontSize: 150 + Math.floor(Math.random() * 50) + "px",
                    textShadow: "9999px 0 24px #eee"
                },
                v: 20
            }
        ];

        let snowflake = this.buildSnowFlake();

        let r = Math.random();
        let i = sizes.length;
        let v = 0;

        while (i--) {
            if (r < sizes[i].r) {
                v = sizes[i].v;
                snowflake.css(sizes[i].css);
                break;
            }
        }

        let x = Math.floor(Math.random() * (this.ww + this.moveSize)) - this.moveSize;
        let y = 0;

        if (typeof initial == "undefined" || !initial) {
            y = -this.moveSize;
        } else {
            y = -this.moveSize + Math.floor(Math.random() * (this.wh + this.moveSize));
        }

        snowflake.css({
            left: x + "px",
            top: y + "px"
        });

        snowflake.data("x", x);
        snowflake.data("y", y);
        snowflake.data("v", v);
        snowflake.data("half_v", Math.round(v * 0.5));

        window.jQuery("body").append(snowflake);
    };

    move = () => {
        if (Math.random() > 0.8) {
            this.xv += -1 + Math.random() * 2;

            if (Math.abs(this.xv) > 3) {
                this.xv = 3 * (this.xv / Math.abs(this.xv));
            }
        }

        let newTime = new Date().getTime();
        let diffTime = newTime - this.prevTime;
        this.prevTime = newTime;

        if (diffTime < this.interval && this.flakeCount < this.absMax) {
            this.addFlake(false);
        } else if (diffTime > this.lifeCycle) {
            window.jQuery("span.snow-flake:first").remove();
            this.flakeCount--;
        }

        let self = this;
        window.jQuery("span.snow-flake").each(function () {
            let x = window.jQuery(this).data("x");
            let y = window.jQuery(this).data("y");
            let v = window.jQuery(this).data("v");
            let half_v = window.jQuery(this).data("half_v");

            y += v;

            x += Math.round(self.xv * v);
            x += -half_v + Math.round(Math.random() * v);

            if (x > self.maxw) {
                x = -self.moveSize;
            } else if (x < self.minw) {
                x = self.ww;
            }

            if (y > self.maxh) {
                window.jQuery(this).remove();

                self.flakeCount--;
                self.addFlake();
            } else {
                window.jQuery(this).data("x", x);
                window.jQuery(this).data("y", y);

                window.jQuery(this).css({
                    left: x + "px",
                    top: y + "px"
                });

                if (v >= 6) {
                    window.jQuery(this).animate({rotate: "+=" + half_v + "deg"}, 0);
                }
            }
        });
    };

    render() {
        return <div />;
    }
}
